import Validator from './validator.js';

export default class NumberMinMaxValidator extends Validator {
    constructor(input) {
        super(input);
    }

    valid() {
        const value = this.input.el.value;
        const min = this.input.el.min;
        const max = this.input.el.max;

        if(this.isNumeric(min) && Number(value) < Number(min)) {
            return false;
        }

        if(this.isNumeric(max) && Number(value) > Number(max)) {
            return false;
        }

        return true;
    }

    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    static applies(input) {
        return input.el.type === 'number';
    }
}
